import React, { PropsWithChildren, useState } from "react";

export type AudioInterfaceContextType = {

  outputAudio?: HTMLAudioElement | null,

  inputAudio?: MediaStream | null,

  setOutputAudio(audio: HTMLAudioElement | null): void,

  setInputAudio(input: MediaStream | null): void
};

export const AudioInterfaceContext = React.createContext<AudioInterfaceContextType>({
  setOutputAudio() { console.warn('no AudioInterface provided, ignorning setOutputAudio()'); },
  setInputAudio() { console.warn('no AudioInterface provided, ignorning setInputAudio()'); }
});

export const AudioInterfaceProvider = ({ children }: PropsWithChildren) => {
  const [outputAudio, setOutputAudio] = useState<HTMLAudioElement | null>(null);
  const [inputAudio, setInputAudio] = useState<MediaStream | null>(null);

  return <AudioInterfaceContext.Provider value={{
    outputAudio,
    inputAudio,
    setOutputAudio,
    setInputAudio
  }}>
    {children}
  </AudioInterfaceContext.Provider>
};
